import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface PaymentMethodsSectionProps {
  paymentMethods: {
    credit_card: boolean;
    paypal: boolean;
    ach: boolean;
    check: boolean;
  };
  autoPayEnabled: boolean;
  onPaymentMethodChange: (method: keyof PaymentMethodsSectionProps['paymentMethods'], value: boolean) => void;
  onAutoPayChange: (enabled: boolean) => void;
  achAvailable?: boolean;
}

export function PaymentMethodsSection({
  paymentMethods,
  autoPayEnabled,
  onPaymentMethodChange,
  onAutoPayChange,
  achAvailable = true,
}: PaymentMethodsSectionProps) {
  return (
    <Card className="mb-6">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold">Payment Methods</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-6">
          {/* Credit Card */}
          <div className="flex items-center gap-2">
            <Checkbox
              id="credit_card"
              checked={paymentMethods.credit_card}
              onCheckedChange={(checked) => onPaymentMethodChange('credit_card', checked as boolean)}
            />
            <Label htmlFor="credit_card" className="text-sm">Credit Card</Label>
          </div>

          {/* ACH */}
          {achAvailable && (
            <div className="flex items-center gap-2">
              <Checkbox
                id="ach"
                checked={paymentMethods.ach}
                onCheckedChange={(checked) => onPaymentMethodChange('ach', checked as boolean)}
              />
              <Label htmlFor="ach" className="text-sm">ACH</Label>
            </div>
          )}

          {/* AutoPay with tooltip */}
          <TooltipProvider>
            <div className="flex items-center gap-2">
              <Checkbox
                id="autopay"
                checked={autoPayEnabled}
                onCheckedChange={onAutoPayChange}
              />
              <Label htmlFor="autopay" className="text-sm">AutoPay</Label>
              <Tooltip>
                <TooltipTrigger asChild>
                  <InfoCircledIcon className="h-4 w-4 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Process payment with saved payment method automatically</p>
                </TooltipContent>
              </Tooltip>
            </div>
          </TooltipProvider>
        </div>
      </CardContent>
    </Card>
  );
} 
